import { ACTIVATE_RULE_FLOWS } from './activateRule';
import { AUDIENCE_FLOWS } from './audience';
import { CAMPAIGN_CREATE_FLOWS } from './campaignCreate';
import { DEACTIVATE_RULE_FLOWS } from './deactivateRule';
import { EDIT_CAMPAIGN_FLOWS } from './editCampaign';
import { OUT_OF_SCOPE_FLOWS } from './outOfScope';
import { REWARD_RULE_LOYALTY_FLOWS } from './rewardRuleLoyalty';
import { IDemoFlow } from './types';

/** In the order the demo chat offers them. */
export const ORBIT_L4_DEMO_FLOWS: IDemoFlow[] = [
  ...DEACTIVATE_RULE_FLOWS,
  ...ACTIVATE_RULE_FLOWS,
  ...EDIT_CAMPAIGN_FLOWS,
  ...AUDIENCE_FLOWS,
  ...CAMPAIGN_CREATE_FLOWS,
  ...REWARD_RULE_LOYALTY_FLOWS,
  ...OUT_OF_SCOPE_FLOWS
];

const key = (question: string) => question.trim().toLowerCase();

export const demoFlowFor = (question: string): IDemoFlow | undefined =>
  ORBIT_L4_DEMO_FLOWS.find(flow => key(flow.prompt) === key(question));
